// extracted by mini-css-extract-plugin
export default {"cls1":"Comment-cls1_Lqf","cls2":"Comment-cls2_AnY Comment-cls1_Lqf"};